import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const WebAppParams = () => {
  const history = useLocation();

  useEffect(() => {
    if (history.pathname === "/") {
      window.Telegram.WebApp.setHeaderColor("#6081bf");
      window.Telegram.WebApp.setBackgroundColor("#6081bf");
    } else {
      window.Telegram.WebApp.setHeaderColor("#6081bf");
      window.Telegram.WebApp.setBackgroundColor("#6081bf");
    }
  }, [history.pathname]);

  return null;
};
